import { Collection } from './Collection';
import { ForwardTaskUserModel } from 'src/app/models/tasks/ForwardTaskUserModel';
import { SubTaskTypeEnum } from './enum/SubTaskTypeEnum';

export class Task {
    taskId!: number;
    taskTitle!: string;
    taskDetails!: string;
    isPrivate!: boolean;
    taskPriorityId!: number;
    taskPriorityName!: string;
    doneSubTaskCount!: number;
    subTaskCount!: number;
    parentTaskId!: number;
    parentTask = {} as this;
    subTasks!: [];
    requestedDate!: '';
    startDate!: '';
    dueDate!: '';
    maximumDueDate!: Date;
    minimumDueDate!: Date;
    completion?: number;
    created!: Date;
    isGroupChairman!: boolean;
    creatorData!: {
        userImage: string;
        userTitle: string;
    };
    groupData = {} as {
        groupId: number,
        groupName: string,
        groupAbbreviation: string
    };
    userData!: {
      userImage: string,
      userTitle: string
    };
    taskAttachments!: [];
    collectionData = {} as Collection;
    canViewSubTasks!: boolean;
    canEdit!: boolean;
    canDelete!: boolean;
    canViewTaskStatusBtn!: boolean;
    canViewMarkAsDoneBtn!: boolean;
    showRequestDueDate!: boolean;
    showReviewTask!: boolean;
    showApprovalMainTask!: boolean;
    isAssignedToMe!: boolean;
    isMarkAsDoneStatus !: boolean;
    canEditOutputs!: boolean;
    showTaskOutputs!: boolean;
    isTaskCreator!: boolean;
    isMainTaskApproved!: boolean;
    isRequestNewDate!: boolean;
    isFollower!: boolean;
    taskStatusName!: string;
    taskStatusId!: number;
    taskStatuses = [];
    forwardUserData!: ForwardTaskUserModel;
    canAddSubTask!: boolean;
    canForwardSubTask!: boolean;
    commentsCount?: number;
    attachmentsCount?: number;
    subTasksDoneCount?: number;
    canEditcompletion?: boolean;
    IsAssignedToMe!: boolean;
    amount!:number | null;
    volunteeringHours!:string | null
    subTaskType!:SubTaskTypeEnum
}
